import { AppState } from './../../../../store/app.states';
import { memberViewOverview_Model } from './selectors';
import { Component, Input, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { OnDestroy } from '@angular/core';
import { RequestAction } from './actions';
import { ComponentBase } from '../../../../views/component-base';
import { MemberPortalSharedState } from '../../store/shared.states';
import { Router } from '@angular/router';
import { commomState_SystemConfig_Config } from 'src/app/store/common/common.selectors';

@Component({
  selector: 'app-member-view-overview',
  templateUrl: './member-view-overview.component.html',
  styleUrls: ['./member-view-overview.component.scss']
})
export class MemberViewOverviewComponent extends ComponentBase implements OnInit, OnDestroy {

  data$ = this.store.pipe(select(memberViewOverview_Model));
  tenantConfig$ = this.appstore.pipe(select(commomState_SystemConfig_Config));

  @Input() itemclass: string = 'w-50';

  constructor(
    public store: Store<MemberPortalSharedState>,
    public appstore: Store<AppState>,
    private router: Router) {
    super();
  }

  ngOnInit() {
    super.ngOnInitBase();
    this.dispatch(this.store,RequestAction());

    this.screenWidthChange(this.appstore, x => { });

  }

  ngOnDestroy() {
    super.ngOnDestroyBase();
  }

  personalDetails() {
    this.router.navigate(['personal-details']);
  }

  changePassword() {
    this.router.navigate(['change-password']);
  }
}
